import { render, staticRenderFns } from "./UserStats.vue?vue&type=template&id=48b96ac0&scoped=true"
import script from "./UserStats.vue?vue&type=script&lang=js"
export * from "./UserStats.vue?vue&type=script&lang=js"
import style0 from "./UserStats.vue?vue&type=style&index=0&id=48b96ac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b96ac0",
  null
  
)

export default component.exports